import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CollectionsComponent } from '@src/app/features/collections/collections/collections.component';
import { AddCollectionComponent } from '@src/app/features/collections/add-collection/add-collection.component';
import { ViewCollectionComponent } from '@app/features/collections/view-collection/view-collection.component';
import { EditCollectionComponent } from '@src/app/features/collections/edit-collection/edit-collection.component';

const routes: Routes = [
  { path: '', component: CollectionsComponent },
  { path: 'add', component: AddCollectionComponent },
  { path: ':collectionId/edit', component: EditCollectionComponent },
  { path: ':collectionId', component: ViewCollectionComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CollectionsRoutingModule { }
